import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * XP to test light gating for logged out SEO discover, brand, supplier, category and PDP pages.
 */
export const FE_LOGGED_OUT_LIGHT_GATING_052925 = experiment({
  name: "FE_LOGGED_OUT_LIGHT_GATING_052925",
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_PERF_APP_WEB", "VISITOR_WEB"],
  notifyAfter: "2025-06-30",
  defaultValue: IThreeVariantXP.Bucket.CONTROL,
  productArea: "LOGGED_OUT_RETAILERS",
});
